var __TEMP__ = require('./_baseClamp.js');var baseClamp = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_shuffleSelf.js');var shuffleSelf = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./values.js');var values = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseSampleSize;
